export const environment = {
  production: true,
  ASSETS_HOST: 'https://assets.edl3.groovemonkee.com',
  API_URL: 'https://api.edl3.groovemonkee.com/a',
  ipp: 25
};
